module.exports = __webpack_public_path__ + "images/dashboard-delay-statistics-26b1fd448ab540c4c60068d32292fcfd.png";